import { client } from "@/utils/client";

// active
// params: { "validate_code": 123456, "client_id":"", "scope":"" }
export function validate(params) {
    return client({
        url: "/oauth/code/",
        method: "get",
        params,
    })
}

// lwa
// data 为 axios 提供的参数
export function postLWACode(code, token) {
    const data = {
        code,
        token
    }
    return client({
        url: "/oauth/lwa/",
        method: "post",
        data
    })
}

// allow
export function getOACode(token) {
    const data = {
        token
    }
    return client({
        url: "/oauth/oa/",
        method: "post",
        data
    })
}


//////////////////
// WEBPACK FOOTER
// ./src/api/oauth.js
// module id = null
// module chunks = 